"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = MarkdatenPage;
const jsx_runtime_1 = require("react/jsx-runtime");
const ReportDisplay_1 = __importDefault(require("@/components/pbi/ReportDisplay"));
const reportConstants_1 = require("@/config/reportConstants");
const powerbiUtils_1 = require("@/utils/powerbiUtils");
const react_router_dom_1 = require("react-router-dom");
function MarkdatenPage() {
    const location = (0, react_router_dom_1.useLocation)();
    const bookmark = location.state && location.state.bookmark ? location.state.bookmark : null;
    const years = location.state && location.state.years ? location.state.years : null;
    const onReportLoaded = (report) => __awaiter(this, void 0, void 0, function* () {
        if (report) {
            yield (0, powerbiUtils_1.setMarktdatenDateFilter)(report, years);
            yield (0, powerbiUtils_1.setMarktdatenTableSort)(report);
        }
    });
    return ((0, jsx_runtime_1.jsx)(ReportDisplay_1.default, { className: "embed-report", reportCode: reportConstants_1.RC_MARKDATEN, bookmark: bookmark, onReportLoaded: onReportLoaded, onButtonClicked: powerbiUtils_1.handleMarktdatenButtonClicked }));
}
